import {
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    MenuItem,
    Stack,
    styled,
    Typography
} from "@mui/material";
import React, { forwardRef, useContext, useImperativeHandle, useState } from "react";
import { AppContext } from "../../lib/Context";
import { getAllAgents } from "../../services/AgentApi";
import { updateContractAgent } from "../../services/ContractApi";
import { handleOpenSnackBar } from "../../utils/helper";
import GlobalButton from "../button";
import Label from "../label";
import AppLoader from "../loader";
import CustomDropDown from "../select";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiPaper-root": {
        width: "500px",
        [theme.breakpoints.down("sm")]: {
            margin: 12,
        },
    },
}));


const UpdateAgentDialog = forwardRef(({ }, ref) => {
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [dialogData, setDialogData] = useState(null);
    const [agentId, setAgentId] = useState("");
    const [allAgents, setAllAgents] = useState([]);
    const { userData } = useContext(AppContext);

    useImperativeHandle(ref, () => ({
        openDialog(params) {
            setDialogData(params);
            setOpen(true);
            handleFetchAllGents();
        },
        disable() {
            handleClose();
        },
    }));

    const handleFetchAllGents = async () => {
        try {
            const response = await getAllAgents();
            if (response?.data.status === "success") {
                let data = response.data.data;
                setAllAgents(data);
            }
        } catch (error) {
            console.error("error", error?.message);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setDialogData(null);
        setAgentId("");
        setAllAgents([]);
        setIsLoading(false);
    };

    const handleUpdate = async () => {

        if (!agentId) {
            handleOpenSnackBar("error", "Please select an agent");
            return;
        }

        const payload = {
            changedBy: userData?.username,
            agentId: agentId,
        };

        try {
            setIsLoading(true);
            const response = await updateContractAgent(dialogData?.prospectId, payload);
            if (response?.data.status === "success") {
                handleOpenSnackBar("success", response?.data?.message);
                dialogData?.getData(dialogData?.prospectId);
                handleClose();
            } else {
                handleOpenSnackBar("error", response?.data?.message);
            }
        } catch (error) {
            console.error("error", error?.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <AppLoader isVisible={isLoading} />

            <Stack
                p={2}
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
            >
                <Typography variant="h5" fontWeight={500}>
                    Update Prospect Agent
                </Typography>
            </Stack>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Label title={"Select Agent"} htmlFor={"select-agent"} />
                        <CustomDropDown
                            id={"select-agent"}
                            required
                            variant={"filled"}
                            value={agentId}
                            name={"agentId"}
                            onChange={(e) => setAgentId(e.target.value)}
                        >
                            {allAgents.map((val, ind) => {
                                const isDisabled = val._id === dialogData?.agentId;
                                return (
                                    <MenuItem key={ind} value={val._id} disabled={isDisabled}>
                                        {val.username}
                                    </MenuItem>
                                );
                            })}
                        </CustomDropDown>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Stack direction={"row"} spacing={2}>
                    <GlobalButton
                        title={"cancel"}
                        handleClickBtn={handleClose}
                        style={{
                            height: 30,
                            borderRadius: 1,
                        }}
                    />
                    <GlobalButton
                        variant={"custom_gradient"}
                        handleClickBtn={handleUpdate}
                        title={"Update"}
                        style={{
                            height: 30,
                            borderRadius: 1,
                        }}
                    />
                </Stack>
            </DialogActions>
        </BootstrapDialog>
    );
});

export default UpdateAgentDialog;
